module.exports = __webpack_public_path__ + "static/james-pond-riEYPSKxoTw-unsplash-840b9f4d75a4f26ab6da46c931e8afb5.jpg";